export enum SortOptions {
  MostRecent = 'MostRecent',
  NameAZ = 'NameAZ',
  NameZA = 'NameZA'
}
